import React from 'react';
import './SignagePlus.css';
import dropdown from '../../assets/icons/signage-plus/dropdown.svg';

function DropdownSelect({ options, value, onChange, placeholder }) {
    const selected = options.find(opt => String(opt.value) === String(value));
    return (
        <div className="dropdown w-100" style={{ position: 'relative !important' }}>
            <button
                className="btn btn-outline-secondary dropdown-toggle w-100 h-54"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                    textAlign: 'left',
                    backgroundColor: 'rgba(248, 249, 252, 1)', // 保持按钮背景色始终为白色
                    borderColor: '#ced4da',   // 保持边框色为默认
                    color: 'rgba(149, 149, 151, 1)', // 保持文字颜色为深色
                }}
            >
                {selected ? selected.label : placeholder}
                <span className="dropdown-arrow">
                    <img src={dropdown} alt="dropdown" style={{ width: 16, height: 16, marginLeft: 8 }} />
                </span>
            </button>
            <ul className="dropdown-menu w-100 dropdown-menu-select" style={{ maxHeight: 240, overflowY: 'auto' }} >
                {options.map(opt => (
                    <li key={opt.value}>
                        <button
                            className={`dropdown-item${String(value) === String(opt.value) ? ' active' : ''}`}
                            type="button"
                            onClick={() => onChange(opt.value)}
                        >
                            {opt.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default DropdownSelect;
